export const LANGUAGES = [
    { code: 'en', label: '🇬🇧 English' },
    { code: 'hi', label: '🇮🇳 Hindi' },
    { code: 'ar', label: '🇸🇦 Arabic' },
    { code: 'cs', label: '🇨🇿 Czech' }
];
